module.exports = __webpack_public_path__ + "img/Infografis_ID_09.c2dfca20.jpg";